"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = canAccessProperty;
function canAccessProperty(key, value) {
  var prop = void 0;

  try {
    prop = value[key];
  } catch (error) {
    console.error(error); // eslint-disable-line no-console
  }

  return !!prop;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@storybook/addon-actions/dist/lib/types/object/canAccessProperty.js
 ** module id = 545
 ** module chunks = 0
 **/